import { Cookies } from "@react-keycloak/ssr";

export class WebCookiePersistor extends Cookies {
  resetTokens() {}
}
